/** Source de hasard : renvoie un nombre dans [0, 1[. Injectable pour les tests. */
export type Aleatoire = () => number;

/** Copie mélangée (Fisher-Yates). */
export function melanger<T>(elements: readonly T[], aleatoire: Aleatoire): T[] {
  const copie = [...elements];
  for (let i = copie.length - 1; i > 0; i--) {
    const j = Math.floor(aleatoire() * (i + 1));
    [copie[i], copie[j]] = [copie[j]!, copie[i]!];
  }
  return copie;
}

/** Générateur reproductible (mulberry32), pour les tests et le débogage. */
export function aleatoireReproductible(graine: number): Aleatoire {
  let etat = graine >>> 0;
  return () => {
    etat = (etat + 0x6d2b79f5) >>> 0;
    let t = etat;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
